import axios from 'axios';
import { aicaBaseUrl, GET } from '../../utils/axios-interceptor';
import { CONSENT_ENDPOINTS } from './constants';
import { ConsentHistoryResponse, ConsentQueryParams } from './types';

// GET /consent/history — org-wide (no `referenceId`).
export function getConsentHistory({ orgId, type }: ConsentQueryParams) {
    return axios<ConsentHistoryResponse>({
        baseURL: aicaBaseUrl,
        url: CONSENT_ENDPOINTS.HISTORY,
        method: GET,
        params: { orgId, type },
    });
}

// GET /consent/auditTrail — org-wide (no `referenceId`). Binary response; the caller must run
// the blob through assertPdfBlob before treating it as a PDF (aica answers a rejected/failed
// request with an HTTP-200 JSON error envelope, not a 4xx).
export function downloadConsentAuditTrail({ orgId, type }: ConsentQueryParams) {
    return axios({
        baseURL: aicaBaseUrl,
        url: CONSENT_ENDPOINTS.AUDIT_TRAIL,
        method: GET,
        params: { orgId, type },
        responseType: 'blob',
    });
}
